<template>
  <div class="animated fadeIn">
    <div v-if="!admin && !current_step">
      <div class="pt-5">
        <b-row class="justify-content-center">
          <b-col md="8">
            <div class="display-4 text-center pb-5">Before we begin</div>
            <p>{{ pre_confirmation_message }}</p>
            <b-alert :show="!signed_in" variant="warning">
              <strong>You are not logged in.</strong> If you would like to link
              your order to an account please
              <router-link to="/login">log in</router-link>
              or
              <router-link to="/register">register</router-link>
              . If you choose to continue you will be proceeding as a guest.
            </b-alert>
            <b-button
              variant="primary"
              size="lg"
              class="mt-5 w-25 d-block mx-auto"
              to="/submissions/add/step/1"
            >
              Begin
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="current_step">
      <basic-heading title="New Project" />
      <project-wizard-steps
        :path="path"
        :step="current_step"
        :project_id="project_id"
        :submission_id="submission_id"
      />
    </div>
  </div>
</template>

<script>
import config from "../config";
import ProjectWizardSteps from "./ProjectWizardSteps";
import BasicHeading from "@/components/shared/BasicHeading";
import { AUTH_CHECK_LOGIN } from "@/store/action-types";

export default {
  name: "ProjectWizard",
  components: { BasicHeading, ProjectWizardSteps },
  props: {
    path: {
      type: String,
      default: () => config.default_path || null
    },
    project_id: {
      type: String,
      default: () => null
    },
    submission_id: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      current_step: null,
      pre_confirmation_message: config.pre_confirmation_message,
      admin: config.admin,
      signed_in: false
    };
  },
  watch: {
    "$route.params.step": {
      handler(step) {
        this.current_step = step ? +step : config.default_step || null;
      },
      deep: true,
      immediate: true
    }
  },
  async beforeCreate() {
    if (!this.admin) {
      this.$store
        .dispatch(AUTH_CHECK_LOGIN, {})
        .then(() => {
          this.signed_in = true;
        })
        .catch(() => {
          this.signed_in = false;
        });
    }
  }
};
</script>
